import React, { Component } from 'react';

class ElementLibraryHeader extends Component {
  render() {
    const { title, instructions } = this.props.i18n;

    return (
      <div className="ElementLibrary-heading mb-32">
        <div className="ElementLibrary-header">{title}</div>
        <div className="ElementLibrary-instructions">{instructions}</div>
      </div>
    );
  }
}

export default ElementLibraryHeader;
